import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import EpgPersistence from '../Nepg/EpgPersistence';
import { DATA_SOURCE_TYPE_DATABASE } from '../Nepg/EpgPersistence';
import RequestManager from '../../requests/RequestManager';
import Utils from '../../utils/Utils';
import EpgTask from '../../requests/tasks/epg/EpgTask';
import store from '../../store';
import EpgDataManager from '../../AAFPersistenceManager/EpgDataManager';
import * as constant from './../../AAFPlayer/constants';
import EventTimeshift from './EventTimeshift';
import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Asset from '../../requests/apa/Asset';
import { Dates } from '../../packages/dates';
import Device from 'src/devices/device';

// Para startover
const range_seconds = 20 * 60;

// Para catchup
const catchup_threshold_to_play_seconds = 60;

/**
 * Seconds to protect catchup
 */
const metadataCatchupProtectDefaultValue =
  '{"default": {"seconds": ' +
  catchup_threshold_to_play_seconds +
  '}, "colombians": {"seconds": ' +
  catchup_threshold_to_play_seconds +
  '}}';

const defautWatermarkPositionX = 50;
const defaultWatermarkPositionY = 50;
const defaultWatermarkWidth = 121;
const defaultWatermarkHeight = 78;

let playerWatermark_metadata_value = undefined;

/**
 * Metadata value, get watermark, catchup, startover, npvr
 * If enabled, metadata value has the name of the key to get image url from apa assets
 *
 * Metadata key name = player_watermark_image
 *
 */
const metadataPlayerWatermark = `
{
    "default":{
       "enable":false
    },

    "colombia":{
       "enable":false,
       "startover":{
          "asset":"player_startover_watermark",
          "size":{
             "width":"71",
             "height":"28"
          },
          "position":{
             "x":"60",
             "y":"60"
          }
       },
       "npvr":{
          "asset":"player_npvr_watermark",
          "size":{
             "width":"71",
             "height":"28"
          },
          "position":{
             "x":"60",
             "y":"60"
          }
       },
       "catchup":{
          "asset":"player_catchup_watermark",
          "size":{
             "width":"71",
             "height":"28"
          },
          "position":{
             "x":"60",
             "y":"60"
          }
       }
    }
 }
`;

const metadataExcededTS = `
{
  "default": {
    "value": 0
  },
  "colombia": {
    "value": 1
  }
}
`;

//const defaultWatermarkImage = 'http://187.191.86.122/FRONTEND/images/player_watermark.png';
const defaultWatermarkImage = '/images/player_watermark.png';

/**
 * Para saber si usamos el flujo del channelRating
 * enable true or false
 */
const getMedatataValue = function(key, defaultValue) {
  const _metadataValue = JSON.parse(Metadata.get(key, defaultValue));

  return _metadataValue;
};

const getUnixTimeSeconds = function(formatTime) {
  return new Dates(formatTime);
};

const eventIsCurrent = function(event) {
  if (event && event.date_begin) {
    const _now = Utils.nowAsTimestampSeconds();
    return event.date_begin <= _now && event.date_end >= _now;
  }

  return false;
};

const usePersistence = function() {
  return EpgPersistence.getDataSource() === DATA_SOURCE_TYPE_DATABASE;
};

const getNowEvent = async function(group_id, cb, checkTS = true) {
  if (!group_id) {
    if (cb) {
      cb(null);
    }
  }

  let validateEvent = false;
  let timeshiftForChannelSeconds = 0;
  if(checkTS) {
    timeshiftForChannelSeconds = ChannelSingleton.getTimeshift(group_id, true);
    validateEvent = timeshiftForChannelSeconds > 0;
  }
  else {
    validateEvent = true;
  }

  new EpgDataManager()
    .getCurrentEventByGroupId(group_id)
    .then(uEvent => {
      if (validateEvent) {
        if (cb) {
          let maxTimeshiftSeconds =
            Utils.nowAsTimestampSeconds() - timeshiftForChannelSeconds;
          if (maxTimeshiftSeconds > uEvent.date_start) {
            uEvent.date_start_original = uEvent.date_start;
            uEvent.date_start = maxTimeshiftSeconds;
          }
          uEvent.max_timeshift = maxTimeshiftSeconds;
          cb(uEvent);
        }
      } else {
        if (cb) {
          cb(null);
        }
      }
    })
    .catch(() => {
      if (cb) {
        cb(null);
      }
    });
};

/**
 *
 * @param {*} group_id del channel
 */
const getTimeshiftByChannel = function(group_id) {
  return ChannelSingleton.getTimeshift(group_id, true);
};

const hasTimeshift = function(group_id) {
  return ChannelSingleton.getTimeshift(group_id, true) > 0;
};

const timeRangeIsInCurrent = function(startTime, endTime) {
  const _now = Utils.nowAsTimestampSeconds();

  return startTime <= _now && endTime >= _now;
};

const ifFireProgressForTimeshift = function(currentContentType, startTime, endTime) {
  let ret = false;
  if (EventTimeshift.isEnabled()) {
    if (Utils.isNotNullOrNotUndefined(currentContentType)) {
      switch (currentContentType) {
        case constant.AAF_CONTENT_IS_TV:
          ret = true;
          break;
        case constant.AAF_CONTENT_IS_STARTOVER:
          if (timeRangeIsInCurrent(startTime, endTime)) {
            ret = true;
          }
          break;
        default:
          break;
      }
    }
  }

  return ret;
};

/**
 *
 * @param {*} maxTimeshift unix timestamp, tiempo máximo de timeshift
 * @param {*} eventDateStart unix timestamp, fecha inicio evento
 * @param {*} eventDateEnd unix timestamp, fecha fin evento
 *
 * *** Este método tambén considera el exceeded timeshift
 */
const eventIsCatchup = function(maxTimeshift, eventDateStart, eventDateEnd) {
  let metadata_exceded_timeShift = calcTSExcedecTime();
  /**
   * Al tiempo máximo de timeshift se le suma el excdente si es que existe
   */
  let _maxTimeshift = maxTimeshift;
  if (!isNaN(metadata_exceded_timeShift) && metadata_exceded_timeShift > 0) {
    _maxTimeshift = maxTimeshift - metadata_exceded_timeShift;
  }

  /**
   * Ahora con el excedente si aplica, se verifica que el programa esté dentro de la ventana de TS + el excedente, y si es así pues play
   */

  /* El timeshift queda entre el date init o el date end */
  let timeshiftBetweenEvent = _maxTimeshift >= eventDateStart && _maxTimeshift < eventDateEnd;

  /* El evento queda delante de maxtimeshift */
  let timeshiftIsBehindEvent = eventDateStart >= _maxTimeshift;

  return timeshiftBetweenEvent || timeshiftIsBehindEvent;
  //return (event.date_begin <= _now && event.date_end >= _now);
};

const timeIsInRange = function(timeIn, startTime, endTime) {
  return timeIn >= startTime && timeIn < endTime;
};

/**
 *
 * @param {*} startTime
 * @param {*} endTime
 *
 * Verifica contra el tiempo disponible del user en Timeshift
 *
 * Regresa null si ya no hay play, dateend del evento quedó detrás del timeshift permitido
 */
const replaceCatchupTime = function(groupId, startTime, endTime) {
  //console.log('[AAF] Catchup - TimeshiftUtil enter, params groupId, startTime, endTime: ' + groupId + ', ' + startTime + ', ' + endTime);
  let result = { groupId, startTime, endTime };
  let timeshiftSeconds = getTimeshiftByChannel(groupId);
  //console.log('[AAF] Catchup - TimeshiftUtil, timeshiftSeconds: ' + timeshiftSeconds);
  let maxTimeshift = Utils.nowAsTimestampSeconds() - timeshiftSeconds;
  //console.log('[AAF] Catchup - TimeshiftUtil, maxTimeshift: ' + maxTimeshift);

  let metadata_exceded_timeShift = calcTSExcedecTime();

  /*  Primero verificar que el evento esté en dentro de la ventana de timeshift
      Para que el evento esté dentro de timeshift se considera:
            * Que la fecha de inicio del evento SEA MAYOR O IGUAL al maxtimeshift
            * Que la fecha de fin del evento SEA MENOR al maxtimeshift
            * El tiempo colchón de TS, exceeded ts time
  */
  if (timeshiftSeconds > 0 && eventIsCatchup(maxTimeshift, startTime, endTime)) {
    /* Almacena el tiempo de colchon que se da al sobre pasar el TimeShift
     Ajusta el tiempo de inicio si es que la fecha de inicio del evento queda más
     atrás en el tiempo en referencia al max TS del user + el exceeded ts time

     ------- tiempo inicio evento ----- max TS + exceeded time -------- max TS --------- tiempo fin evento ----- now ----------- >

    */
    result.startTime = exededTS(metadata_exceded_timeShift, timeshiftSeconds, result);
  } else {
    //console.log('[AAF] Catchup - TimeshiftUtil, el evento ya no está en ventana, no se playea');
    // Si ya no entra no se puede playear
    result = null;
  }

  return result;
};

/**
 * @param {*} metadata_exceded_timeShift //Contiene el valor de la llave, que indica el tiempo en colchon para ver el contenido
 * @param {*} timeshiftSeconds //Paquete en segundos que adquirió el cliente
 * @param {*} result //Hora inicio, termino y id de conteido
 */
const exededTS = function(metadata_exceded_timeShift, timeshiftSeconds, result) {
  return timeshiftSeconds > 0
    ? recalculateStartTime(metadata_exceded_timeShift, result, timeshiftSeconds)
    : null;
};

/**
 * @param {*} metadata_exceded_timeShift //Contiene el valor de la llave, que indica el tiempo en colchon para ver el contenido
 * @param {*} result //Hora inicio, termino y id de conteido
 * @param {*} timeshiftSeconds //Paquete en segundos que adquirió el cliente
 */
const recalculateStartTime = function(metadata_exceded_timeShift, result, timeshiftSeconds) {
  //Obtenemos el tiempo que dura el evento en segundos
  let nowTime = Utils.nowAsTimestampSeconds();
  let tsExedeTime = exededTimeCalculate(nowTime, timeshiftSeconds, metadata_exceded_timeShift);
  if (result.startTime < tsExedeTime) {
    // Si el inicio del programa es menor a TS + el valor que viene en la llave, solo se le permite ver el timeshift que tenga contratado
    return nowTime - timeshiftSeconds + 60; // <-- 60 segundos de protección a la llamada a getmedia (starttime recortado a max ts + 60s adelante)
  } else {
    console.log('Inicip-Normal', result.startTime);
    return result.startTime;
  }
};

const exededTimeCalculate = function(nowTime, timeshiftSeconds, metadata_exceded_timeShift) {
  let calculateTime = nowTime - (timeshiftSeconds + metadata_exceded_timeShift);
  return calculateTime != NaN ? calculateTime : 0;
};

const calcTSExcedecTime = function() {
  const region = DeviceStorage.getItem('region');
  const metadata_exceded_timeShift = getMedatataValue('exceded_ts', metadataExcededTS);
  if (region) {
    return metadata_exceded_timeShift[region]
      ? converHourstoSecond(metadata_exceded_timeShift[region].value)
      : converHourstoSecond(metadata_exceded_timeShift['default'].value);
  } else {
    return metadata_exceded_timeShift['default']
      ? converHourstoSecond(metadata_exceded_timeShift['default'].value)
      : 0;
  }
};

const converHourstoSecond = function(hours) {
  return hours == NaN ? 0 : hours * 60 * 60;
};

/**
 *
 */
const getRegionalizedPlayerWatermarkData = function() {
  if (playerWatermark_metadata_value !== undefined) {
    return playerWatermark_metadata_value;
  }

  const region = DeviceStorage.getItem('region');
  const waterMarkData = getMedatataValue('player_watermark_image', metadataPlayerWatermark);
  if (
    region &&
    Utils.isObject(waterMarkData) &&
    Utils.isNotNullOrNotUndefined(waterMarkData[region]) &&
    Utils.isNotNullOrNotUndefined(waterMarkData[region]['enable']) &&
    waterMarkData[region]['enable'] === true
  ) {
    playerWatermark_metadata_value = waterMarkData[region];
  } else if (
    Utils.isNotNullOrNotUndefined(waterMarkData['default']) &&
    Utils.isNotNullOrNotUndefined(waterMarkData['default']['enable']) &&
    waterMarkData['default']['enable'] === true
  ) {
    playerWatermark_metadata_value = waterMarkData['default'];
  } else {
    playerWatermark_metadata_value = null;
  }

  return playerWatermark_metadata_value;
};

const getRegionalizedPlayerWatermarkDataAttributes = function(imageData) {
  let _imageData = {};
  /**
   * onst defautWatermarkPositionX = 50;
   const defaultWatermarkPositionY = 50;
   const defaultWatermarkWidth = 121;
   const defaultWatermarkHeight = 78;
   /**
   */
  let watermarkImgPosition = { x: defautWatermarkPositionX, y: defaultWatermarkPositionY };
  let watermarkImgSize = { width: defaultWatermarkWidth, height: defaultWatermarkHeight };
  if (
    Utils.isObject(imageData['position']) &&
    Utils.isNotNullOrNotUndefined(imageData['position']['x']) &&
    Utils.isNotNullOrNotUndefined(imageData['position']['y'])
  ) {
    watermarkImgPosition.x = imageData['position']['x'];
    watermarkImgPosition.y = imageData['position']['y'];
  }

  if (
    Utils.isObject(imageData['size']) &&
    Utils.isNotNullOrNotUndefined(imageData['size']['width']) &&
    Utils.isNotNullOrNotUndefined(imageData['size']['height'])
  ) {
    watermarkImgSize.width = imageData['size']['width'];
    watermarkImgSize.height = imageData['size']['height'];
  }

  _imageData.position = watermarkImgPosition;
  _imageData.size = watermarkImgSize;

  return _imageData;
};

/**
 *
 */
const getPlayerWatermarkData = function(currentContentType) {
  let image_data = null;
  let imgAttr = null;
  let _image_data_metadata = getRegionalizedPlayerWatermarkData();

  if (Utils.isNotNullOrNotUndefined(currentContentType) && _image_data_metadata) {
    switch (currentContentType) {
      case constant.AAF_CONTENT_IS_CATCHUP:
        if (_image_data_metadata['catchup']) {
          imgAttr = getRegionalizedPlayerWatermarkDataAttributes(
            _image_data_metadata['catchup']
          );
          image_data = {
            position: imgAttr.position,
            size: imgAttr.size
          };
          image_data.image = Asset.get(
            _image_data_metadata['catchup']['asset'],
            defaultWatermarkImage
          );
        }
        break;
      case constant.AAF_CONTENT_IS_STARTOVER:
        if (_image_data_metadata['startover']) {
          imgAttr = getRegionalizedPlayerWatermarkDataAttributes(
            _image_data_metadata['startover']
          );
          image_data = {
            position: imgAttr.position,
            size: imgAttr.size
          };
          image_data.image = Asset.get(
            _image_data_metadata['startover']['asset'],
            defaultWatermarkImage
          );
        }
        break;
      case constant.AAF_CONTENT_IS_NPVR:
        if (_image_data_metadata['npvr']) {
          imgAttr = getRegionalizedPlayerWatermarkDataAttributes(
            _image_data_metadata['npvr']
          );
          image_data = {
            position: imgAttr.position,
            size: imgAttr.size
          };
          image_data.image = Asset.get(
            _image_data_metadata['npvr']['asset'],
            defaultWatermarkImage
          );
        }
        break;
      default:
        break;
    }
  }

  return image_data;
};

const initPlayerWaterMark = function() {
  getRegionalizedPlayerWatermarkData();
};

const playerWatermarkEnabled = function() {
  return Utils.isNotNullOrNotUndefined(getRegionalizedPlayerWatermarkData());
};

const getDevicePlatform = () => {
  const device = Device.getDevice();
  const platform = device.getPlatform();

  if (platform) {
    return platform;
  }
  return null;
}

const getTimeshiftStreamTypes = () => {
  const platform = getDevicePlatform();

  let catchupStreamType = null;
  let timeshiftStreamType = null;
  let npvrStreamType = null;
  const streams = Utils.getFallBackMetadata();

  if (streams) {
    if (typeof streams !== 'undefined' && streams['catchup']) {
      catchupStreamType = streams['catchup'][0];
    }
    if (typeof streams !== 'undefined' && streams['timeshift']) {
      timeshiftStreamType = streams['timeshift'][0];
    }
    if (typeof streams !== 'undefined' && streams['npvr']) {
      npvrStreamType = streams['npvr'][0];
    }
  }

  return {
      catchup: catchupStreamType,
      timeshift: timeshiftStreamType,
      npvr: npvrStreamType,
  }
}

const disableTimeshiftKeys = () => {
  const TIMESHIFT_NPVR_CONFIGURATION_KEY = 'timeshift_npvr_configuration';
  const EVENTTIMESHIFT_KEY = 'eventTimeshift';
  const PROVIDERS_LABEL_CONFIGURATION_KEY = 'providers_label_configuration';
  const NPVR_EPG_RECORDING_ICON_KEY = 'npvr_epg_recording_icon';

  const timeshift_npvr_configuration_value = Metadata.get(TIMESHIFT_NPVR_CONFIGURATION_KEY, null);
  const eventTimeshift_value = Metadata.get(EVENTTIMESHIFT_KEY, null);
  const providers_label_configuration_value = Metadata.get(PROVIDERS_LABEL_CONFIGURATION_KEY, null);
  const npvr_epg_recording_icon_value = Metadata.get(NPVR_EPG_RECORDING_ICON_KEY, null);

  timeshift_npvr_configuration_value && 
  Metadata.set(TIMESHIFT_NPVR_CONFIGURATION_KEY, '{"timeshift": {"enable":false},"vcard_past_epg_event":{"enable":false},"npvr_button_record":{"enable":false}}');

  eventTimeshift_value && 
  Metadata.set(EVENTTIMESHIFT_KEY, '{"enable":false}');

  providers_label_configuration_value && 
  Metadata.set(PROVIDERS_LABEL_CONFIGURATION_KEY, '{"default":{}}');

  npvr_epg_recording_icon_value && 
  Metadata.set(NPVR_EPG_RECORDING_ICON_KEY, '{"default": {"enable": false, "canRecord": {"asset": "npvr_epg_recording_icon_canRecord"},"toRecord": {"asset": "npvr_epg_recording_icon_toRecord"},"recordingBlink": {"asset": "npvr_epg_recording_icon_recordingBlink"},"recorded": {"asset": "npvr_epg_recording_icon_recorded"}}}');
}

const getSDKVersion = () => {
  return new Promise((resolve, reject) => {
    const ID = Device.getDevice().getId();
    const receiveSDKVersion = sdkVersion => {
      if (sdkVersion) {
        resolve(sdkVersion)
      } else {
        reject(null);
      }
    };
    ID.getSDKVersion(receiveSDKVersion);
  });
}

const hasTimeshiftSupported = async (platform) => {
  const timeshiftStreamTypes = getTimeshiftStreamTypes();
  const timeshiftStreamType = timeshiftStreamTypes ? timeshiftStreamTypes.timeshift : null;
  const npvrStreamType = timeshiftStreamTypes ? timeshiftStreamTypes.npvr : null;
  switch (platform) {
    case 'web0s':
      if (npvrStreamType) {
        let sdkVersion = null;
        try {
          const sdkVersionResult = await getSDKVersion();
          sdkVersion = sdkVersionResult;
        } catch (error) {
          console.log("[TimeshiftUtil] web0s - Failed to getSDKVersion", error);
        }
        if (npvrStreamType === 'hls' && sdkVersion && sdkVersion < 4) {
          console.log("[TimeshiftUtil] web0s - Timeshift is not supported:", "NPVR stream type:", npvrStreamType, "SDK version:", sdkVersion);
          return false;
        }
        return true;
      }
      return false;
    case 'hisense':
      if (timeshiftStreamType) {
        const userAgent = navigator.userAgent.toLowerCase();
        const isVidaa = userAgent.indexOf('vidaa') !== -1 ? true : false;
        if (!isVidaa) {
          console.log("[TimeshiftUtil] hisense - Timeshift is not supported:", "userAgent:", userAgent);
          return false;
        }
        return true;
      }
      return false;
    default:
      if (timeshiftStreamType) {
        return true;
      }
      return false;
  }
}

/**
 * Export module
 */
const TimeshiftUtil = {
  getNowEvent: getNowEvent,
  usePersistence: usePersistence,
  hasTimeshift: hasTimeshift,
  timeRangeIsInCurrent: timeRangeIsInCurrent,
  ifFireProgressForTimeshift: ifFireProgressForTimeshift,
  replaceCatchupTime: replaceCatchupTime,
  getPlayerWatermarkData: getPlayerWatermarkData,
  initPlayerWaterMark: initPlayerWaterMark,
  playerWatermarkEnabled: playerWatermarkEnabled,
  calcTSExcedecTime: calcTSExcedecTime,
  getDevicePlatform: getDevicePlatform,
  hasTimeshiftSupported: hasTimeshiftSupported,
  disableTimeshiftKeys: disableTimeshiftKeys,
};

export { TimeshiftUtil };

/*
HKS: "0m8a4ecq9dv6tjpc6jo5h9l5r1"
api_version: "v5.87"
authpn: "amco"
authpt: "12e4i8l6a581a"
container_width: "937"
date_from: "20190805053000"
date_to: "20190805193000"
device_category: "stb"
device_id: "2153017310HYGA500086"
device_manufacturer: "huawei"
device_model: "EC6108V9"
device_type: "ptv"
epg_version: "35469"
event_image: "true"
filter_inactive: "0"
format: "json"
from: "134"
horizontal_blocks: "7"
infinite_fix: "17"
interval_size: "30"
metadata: "full"
node_id: "19348"
now: "20190805114500"
quantity: "41"
region: "colombia"
visible_time: "120"
*/

//   // Escenario que excede 30 min del timeshift + el colchon
//   result.startTime='1580475600'; //7:00 am
//   result.endTime='1580486400'; //10:00 am

//   // Escenario que excede 60 min del timeshift + el colchon
//   result.startTime='1580472000'; //6:00 am
//   result.endTime='1580486400'; //10:00 am

//   // Escenario esta exacto las 6 horas timeshift + el colchon
//   result.startTime='1580473800'; //6:30 am
//   result.endTime='1580486400'; //10:00 am

//   //// Escenario que excede 60 min del timeshift + el colchon pero el final del programa es menor al timeshift normal
//   result.startTime='1580472000'; //6:30 am
//   result.endTime='1580473800'; //10:00 am

//  // 2 Horas de paquete de TimeShift
//   timeshiftSeconds = '7200'

//   // Escenario que excede 30 min del timeshift + el colchon pero si se reproducen las ultimas 2 horas del programa
//   result.startTime='1580482800'; //7:00 am
//   result.endTime='1580495400'; //10:00 am

//   // La programación no excede el ts + conshon de tiempo que quivale a 3 horas cerradas, el contenido se reproduce completo
//   result.startTime='1580484600'; //9:30 am
//   result.endTime='1580495400'; //12:30pm

//   // Rebasa 30 min el ts y el colchon, solo se reproducen las ùltimas 2 horas del programa
//   result.startTime='1580486400'; //10:00 am
//   result.endTime='1580495400'; //12:30pm

//   // Escenario que excede 30 min del timeshift + el colchon el fin del programa queda fuera ts de 2 horas de contrato, no se reproduce nada
//   result.startTime='1580482600'; //10:00 am
//   result.endTime='1580484600'; //12:30pm

// Para pruebas
/*
        // Todas las pruebas de abajo con fecha del 19 de ago de 2019

     // Fecha inicio: 18:00
     // Fecha fin: 19:00
     // Maxtimeshift: 18:30
     maxTimeshift = 1566239400
     startTime = 1566237600
     endTime = 1566241200

     // Fecha inicio: 18:30
     // Fecha fin: 19:00
     // Maxtimeshift: 18:00
     maxTimeshift = 1566237600
     startTime = 1566239400
     endTime = 1566241200

     // Fecha inicio: 18:00:30
     // Fecha fin: 19:00:00
     // Maxtimeshift: 18:00:00
     maxTimeshift = 1566237600
     startTime = 1566237630
     endTime = 1566241200
     */



// WEBPACK FOOTER //
// ./src/AAF/Timeshift/TimeshiftUtil.js